<template>
  <Loader :loader="loading.activity" />
  <main class="flex flex-col gap-4 py-6" v-if="!loading.activity">
    <Button @click.prevent="goBack()" class="btn-simple flex flex-row gap-4">
      <v-icon name="md-arrowbackiosnew-round" />
      <h6>{{ "Voltar" }}</h6>
    </Button>

    <div class="flex flex-col md:flex-row justify-between mx-8 gap-8 text-h-primary-500">
      <h5>{{ activity?.activity?.title }}</h5>
      <div class="flex flex-col sm:flex-row gap-2 sm:items-center">
        <div class="flex flex-row gap-2 items-center" v-if="activity?.feedback">
          <h6>{{ "Nota:" }}</h6> 
          <span class="bg-h-primary-100 p-2 rounded-md">{{ `${activity?.score} / ${activity?.activity?.scoreRange}` }}</span>
        </div>
        <div class="flex flex-row gap-2 items-center">
          <h6>{{ "Status:" }}</h6>
        <span :class="activity?.status?.class">
          <v-icon :name="activity?.status?.icon" />
          {{ activity?.status?.text }}
        </span>
        </div>   
      </div>
    </div>
    <div
      class="p-4 rounded-md border border-b-4 border-b-h-primary-500 flex flex-col gap-4 mx-8"
    >
      <span
        ><strong>{{
          $t("labels.generic", { pt: "Data de Início:", en: "Inital Date" })
        }}</strong>
        {{ initialDate(activity.activity?.startDate) }}
      </span>
      <span
        ><strong>{{
          $t("labels.generic", { pt: "Prazo de entrega:", en: "Deadline" })
        }}</strong>
        {{ finalDate(activity.activity?.finalDate) }}
      </span>
      <span
        ><strong>{{
          $t("labels.generic", { pt: "Pontuação:", en: "Score:" })
        }}</strong>
        {{ scoreRange }}
      </span>
      <span
        ><strong>{{
          $t("labels.generic", { pt: "Descrição:", en: "Description:" })
        }}</strong>
        <div v-html="activity?.activity?.description" class="ql-editor"></div>
      </span>
      <span v-if="activity?.activity?.materials?.length > 0"
        ><strong>{{
          $t("labels.generic", {
            pt: "Arquivo de apoio enviado:",
            en: "Supporting file sent:",
          })
        }}</strong>
        <div class="flex flex-wrap gap-4">
          <div
          v-for="(material, index) in activity?.activity?.materials"
          :key="index"
          class="flex gap-4 py-3"
        >
          <div
            class="!bg-h-primary-50 rounded-sm text-h-primary-700 w-[240px] flex flex-row items-center justify-between p-4 cursor-pointer"
            @click.prevent="downloadMaterial(material?.id)"
          >
            <div class="flex flex-row items-center gap-2">
              <v-icon name="hi-solid-document-text" />
              <p>{{ `${material?.name}.${material?.mimetype}` }}</p>
            </div>

            <v-icon name="hi-solid-download" />
          </div>
        </div>
        </div>
       
      </span>
    </div>

    <span class="flex flex-row-reverse mx-8" v-if="isNotExpired">
      <Button
        :label="
          $t('labels.generic', { en: 'Send Activity', pt: 'Enviar Atividade' })
        "
        icon="pi pi-file-plus"
        class="btn-primary"
        @click="showDialogForm()"
      />
    </span>
    <div v-if="(activity?.status?.value === activityStatus.ASSIGNED ||activity?.status?.value === activityStatus.FEEDBACK) && (activity?.textAnswer || activity?.mediaAnswer?.length > 0)">
      <h5 class="mx-8 my-2 text-h-primary-500">{{ "Envio" }}</h5>
      <div class="border border-b-h-primary-500 border-b-4 rounded-md p-4 mx-8 flex flex-col gap-4">
        <h5 class="pb-4">{{ "Atividade Enviada - " + activity?.activity?.title }}</h5>
        <p>
        <strong>{{ "Comentário: " }}</strong>
        {{ activity?.textAnswer?? "Nenhum comentário" }}
      </p>
      <p v-if="activity?.mediaAnswer?.length > 0">
        <strong>{{ "Anexo enviado:" }}</strong>
        <div v-for="(media, index) in activity?.mediaAnswer" :key="index" class="py-3"
         @click.prevent="downloadMaterial(media?.id)"
        >
          <div class="flex flex-row justify-between items-center p-4 rounded-sm bg-h-primary-50 w-[240px] cursor-pointer">
           <div class="flex flex-row items-center gap-2">
            <v-icon name="io-document-text-sharp" />
            <p>{{ media.name +"."+media.mimetype  }}</p>
           </div>
            <v-icon name="hi-solid-download"/>
          </div>
        </div>
      </p>
      </div>
      <div v-if="activity?.status?.value === activityStatus.FEEDBACK" class="py-6">
        <h5 class="mx-8 my-2 text-h-primary-500">{{ "Feedbacks" }}</h5>
        <div class="border border-b-h-primary-500 border-b-4 rounded-md py-6 p-4 mx-8 flex flex-col gap-4 h-20">
         <p>
          <strong>{{ "Comentário do Professor:" }}</strong>
          {{ activity?.feedback?? "Nenhum comentário adicionado" }}
         </p>  
        </div>
      </div>
      
    </div>
    <Dialog
      v-model:visible="showDialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '45vw' }"
      :modal="true"
      :draggable="false"
      :header="'Enviar atividade'"
    >
      <FormStudentActivity
        :activityId="activityId"
        v-model:visible="showDialog"
        @activitySent="getActivity()"
      />
    </Dialog>
  </main>
</template>
<script lang="ts">
import { ActivityRest } from "@/services/rest/activity.rest";
import { MediasRest } from "@/services/rest/media.rest";
import { GenericsUtils } from "@/utils/generics.util";
import moment from "moment";
import { defineAsyncComponent, defineComponent } from "vue";
import { toDomainActivity } from "./activity.mapper";
import { ActivityStatus } from "@/models/activity.model"; 

const FormStudentActivity = defineAsyncComponent(
  () => import("./Form/form-student-activity.vue")
);
export default defineComponent({
  data() {
    return {
      activityId: this.$route.params.activityId as string,
      activity: {} as any,
      loading: { activity: false },
      showDialog: false,
    };
  },
  components: { FormStudentActivity },
  computed: {
    rest(): ActivityRest {
      return new ActivityRest();
    },
    scoreRange(): string {
      return this.activity?.activity?.scoreRange
        ? `0 - ${this.activity?.activity?.scoreRange}`
        : " ----- ";
    },
    utils(): GenericsUtils {
      return new GenericsUtils();
    },
    mediaRest(): MediasRest {
      return new MediasRest();
    },
    isNotExpired(): boolean {
      if (!this.activity?.activity?.finalDate) return false;
      const date = this.activity?.activity?.finalDate;
      return moment([date[0], date[1] - 1, date[2], date[3], date[4]]).isAfter(
        moment()
      );
    },
    activityStatus():typeof ActivityStatus{
      return ActivityStatus
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getActivity() {
      this.loading.activity = true;
      this.rest.getStudentActivitiesById(this.activityId).subscribe({
        next: (response) => {
          
          this.activity = toDomainActivity(response);
          this.loading.activity = false;
        },
        error: () => {
          this.loading.activity = false;
        },
        complete: () => {
          this.loading.activity = false;
        },
      });
    },
    initialDate(date: any) {
      if (!date) return "";
      return moment([date[0], date[1] - 1, date[2], date[3], date[4]])
        .locale("pt-BR")
        .format("L");
    },
    finalDate(date: any) {
      if (!date) return "";
      return moment([date[0], date[1] - 1, date[2], date[3], date[4]])
        .locale("pt-BR")
        .format("LLL");
    },
    async downloadMaterial(id: string) {
      this.mediaRest.getMedia(id).subscribe({
        next: async (response) => {
          const mediaUrl = this.utils.getSecureUrl(response.url);
          try {
            const fetchResponse = await fetch(mediaUrl);
            const blob = await fetchResponse.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = response.name || "download";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error("Erro ao fazer download:", error);
          }
        },
      });
    },
    showDialogForm() {
      this.showDialog = true;
    },
  },
  mounted() {
    this.getActivity();
  },
});
</script>
